// extracted by mini-css-extract-plugin
export default {"MainBlock":"OptionHeaderInfoBox_MainBlock__ZQbG8","OptionHeaderInfoBoxTitle":"OptionHeaderInfoBox_OptionHeaderInfoBoxTitle__W-aD4"};